__turbopack_context__.v({
  "list": "ShopsList-module-scss-module__ZrHXSG__list",
  "mapBalloon__button": "ShopsList-module-scss-module__ZrHXSG__mapBalloon__button",
  "root": "ShopsList-module-scss-module__ZrHXSG__root",
  "shop": "ShopsList-module-scss-module__ZrHXSG__shop",
  "shop__active": "ShopsList-module-scss-module__ZrHXSG__shop__active",
  "shop__address": "ShopsList-module-scss-module__ZrHXSG__shop__address",
  "shop__info": "ShopsList-module-scss-module__ZrHXSG__shop__info",
  "shop__isAvailable": "ShopsList-module-scss-module__ZrHXSG__shop__isAvailable",
  "shop__metro": "ShopsList-module-scss-module__ZrHXSG__shop__metro",
  "shop__metro__blue": "ShopsList-module-scss-module__ZrHXSG__shop__metro__blue",
  "shop__metro__green": "ShopsList-module-scss-module__ZrHXSG__shop__metro__green",
  "shop__metro__orange": "ShopsList-module-scss-module__ZrHXSG__shop__metro__orange",
  "shop__metro__purple": "ShopsList-module-scss-module__ZrHXSG__shop__metro__purple",
  "shop__metro__red": "ShopsList-module-scss-module__ZrHXSG__shop__metro__red",
  "shop__schedule": "ShopsList-module-scss-module__ZrHXSG__shop__schedule",
});
